import { Grid } from '@kluein/klue-ui';

import CompanyFavorite from 'pages/company/partials/CompanyFavorite';
import TEST_IDS from 'test-ids';

import type { CompanyFavoriteType } from 'pages/company/Company.types';

const FAVORITE_MIN_WIDTH = '286px';

const DashboardFavorites = ({
  favorites,
}: {
  favorites: CompanyFavoriteType[];
}) => {
  const sortedFavorites = [...favorites].sort((a, b) =>
    a.name.localeCompare(b.name),
  );
  return (
    <Grid
      pad={{ vertical: 'large' }}
      style={{
        gridTemplateColumns: `repeat(auto-fill, minmax(${FAVORITE_MIN_WIDTH}, 1fr))`,
      }}
      gap="large"
      data-test-id={TEST_IDS.dashboard.favoritesSection}
    >
      {sortedFavorites.map((company) => (
        <CompanyFavorite key={company.id} company={company} />
      ))}
    </Grid>
  );
};

export default DashboardFavorites;
